"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Sanitizes the input string or object to protect against cross-site scripting (XSS) attacks.
 * @param {boolean} flag - Indicates whether the input is an object or a string.
 * @param {string|object} dirty - The input to be sanitized.
 * @returns {string|object} - The sanitized output.
 */
var xssPurifier = function xssPurifier(flag, dirty) {
  var clean = null;
  if (flag) {
    Object.keys(dirty).forEach(function (key) {
      dirty[key] = xssPurify(dirty[key]);
    });
    clean = dirty;
  } else {
    clean = xssPurify(dirty);
  }
  return clean;
};

/**
 * Sanitizes the input string to protect against cross-site scripting (XSS) attacks.
 * @param {string} dirty - The input string to be sanitized.
 * @returns {string} - The sanitized output string.
 */
var xssPurify = function xssPurify(dirty) {
  if (typeof dirty === "string") {
    return _dompurify.default.sanitize(dirty);
  }
  return dirty;
};
var XssSanitizer = {
  /**
   * Sanitizes the input string to protect against cross-site scripting (XSS) attacks.
   * @param {string} dirty - The input string to be sanitized.
   * @returns {string} - The sanitized output string.
   */
  purifierString: function purifierString(dirty) {
    return xssPurifier(false, dirty);
  },
  /**
   * Sanitizes the input object to protect against cross-site scripting (XSS) attacks.
   * @param {object} dirty - The input object to be sanitized.
   * @returns {object} - The sanitized output object.
   */
  purifierObject: function purifierObject(dirty) {
    return xssPurifier(true, dirty);
  }
};
var _default = XssSanitizer;
exports.default = _default;